import React, { useState, useEffect } from 'react';
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";

function AddUniversity({formData, setFormData, handleChange}) {
  
  useGSAP(() => {
    const fields = document.querySelectorAll(".relative");
  
    fields.forEach((field) => {
      const input = field.querySelector("input, select");
      const label = field.querySelector("label");
      const pLabel = field.querySelector("p"); // Error message <p> element (optional)
  
      if (!input || !label) {
        // console.warn("Missing input or label in field:", field);
        return; // Skip this field if input or label is missing
      }
  
      // Initial state check for pre-filled values
      if (input.value !== "") {
        gsap.set(label, { 
          top: -10, 
          fontSize: "0.70rem", 
          color: "#6b7280" 
        });
      }
  
      // Add focus event listener
      input.addEventListener("focus", () => {
        gsap.to(label, { top: -10, fontSize: "0.70rem", color: "#22c55e", duration: 0.25 }); // Set label to green
        gsap.to(input, { borderColor: "#22c55e", duration: 0.25 }); // Set border to green
        if (pLabel) {
          pLabel.classList.remove("text-red-500"); // Remove red error text
          pLabel.classList.add("text-gray-500"); // Set label text color to gray
        }
      });
  
      // Add input event listener
      input.addEventListener("input", () => {
        if (input.value !== "") {
          gsap.to(label, { color: "#22c55e", duration: 0.25 }); // Keep label green while typing
          gsap.to(input, { borderColor: "#22c55e", duration: 0.25 }); // Keep border green while typing
          if (pLabel) {
            pLabel.classList.remove("text-red-500"); // Remove red error message
            pLabel.classList.add("text-gray-500"); // Normal label text
          }
        }
      });
  
      // Add blur event listener
      input.addEventListener("blur", () => {
        if (input.value === "") {
          // Field is empty: Show error styles
          gsap.to(label, { top: 10, fontSize: "1rem", color: "#6b7280", duration: 0.25 });
          gsap.to(input, { borderColor: "#d5d7db", duration: 0.25 });
          // input.classList.add("error-border"); // Red border when field is empty
          // if (pLabel) {
          //   pLabel.textContent = `Required *`; // Update error message
          //   pLabel.classList.add("text-red-500"); // Set error message text to red
          // }
        } else {
          // Field has a value: Keep green styles
          input.classList.remove("error-border");
          gsap.to(input, { borderColor: "#d5d7db", duration: 0.25 }); // set gray border
          gsap.to(label, { 
            top: -10, 
            fontSize: "0.70rem", 
            color: "#6b7280", 
            duration: 0.25 
          }); // set gray label
          if (pLabel) {
            pLabel.textContent = `Please enter your ${label.textContent.toLowerCase()}`;
            pLabel.classList.remove("text-red-500"); // Remove red error message
            pLabel.classList.add("text-gray-500"); // Set label text color to gray
          }
        }
      });
    });
  }, [formData]);

  return (
    <form>
      <h2 className="text-gray-800 text-lg font-semibold mb-4">Add University</h2>
      <hr className="border-t border-gray-300 mb-4" />

      {/* First Row of Fields */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6 text-left">
      <div className="relative">
          <label htmlFor="universityCountry" className="absolute text-sm text-gray-500 top-2 left-3 bg-white px-1">University Country</label>
          <select 
            id="universityCountry" 
            value={formData.universityCountry || ''} 
            className="w-full p-2 border rounded" 
            onChange={handleChange}
          >
            <option value="" hidden></option>
            <option value="UK">UK</option>
            <option value="USA">USA</option>
          </select>
          <p className="text-gray-500 text-xs mt-1">Please Select University Country</p>
        </div>

        <div className="relative">
          <label htmlFor="universityName" className="absolute text-sm text-gray-500 top-2 left-3 bg-white px-1">University Name</label>
          <input 
            id="universityName" 
            type="text" 
            value={formData.universityName || ''} 
            className="w-full p-2 border rounded" 
            onChange={handleChange} 
          />
          <p className="text-gray-500 text-xs mt-1">Please Type University Name</p>
        </div>
        <div className="relative">
          <label htmlFor="abbreviation" className="absolute text-sm text-gray-500 top-2 left-3 bg-white px-1">Abbreviation</label>
          <input 
            id="abbreviation" 
            type="text" 
            value={formData.abbreviation || ''} 
            className="w-full p-2 border rounded" 
            onChange={handleChange} 
          />
          <p className="text-gray-500 text-xs mt-1">Please enter University abbreviation (e.g, UCL)</p>
        </div>
        <div className="relative">
          <label htmlFor="address" className="absolute text-sm text-gray-500 top-2 left-3 bg-white px-1">Address</label>
          <input 
            id="address" 
            type="text" 
            value={formData.address || ''} 
            className="w-full p-2 border rounded" 
            onChange={handleChange} 
          />
          <p className="text-gray-500 text-xs mt-1">Please enter Address</p>
        </div>
      

      {/* Second Row of Fields */}
      {/* <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6 text-left"> */}
        <div className="relative">
          <label htmlFor="coordinates" className="absolute text-sm text-gray-500 top-2 left-3 bg-white px-1">Coordinates</label>
          <input 
            id="coordinates" 
            type="text" 
            value={formData.coordinates || ''} 
            className="w-full p-2 border rounded" 
            onChange={handleChange} 
          />
          <p className="text-gray-500 text-xs mt-1">Please enter coordinates</p>
        </div>
        <div className="relative">
          <label htmlFor="region" className="absolute text-sm text-gray-500 top-2 left-3 bg-white px-1">Region</label>
          <input 
            id="region" 
            type="text" 
            value={formData.region} 
            className="w-full p-2 border rounded" 
            onChange={handleChange} 
          />
          <p className="text-gray-500 text-xs mt-1">Please enter Region</p>
        </div>
        <div className="relative">
          <label htmlFor="cityTown" className="absolute text-sm text-gray-500 top-2 left-3 bg-white px-1">City/Town</label>
          <input 
            id="cityTown" 
            type="text" 
            value={formData.cityTown || ''} 
            className="w-full p-2 border rounded" 
            onChange={handleChange} 
          />
          <p className="text-gray-500 text-xs mt-1">Please enter City/Town</p>
        </div>
     

      {/* Third Row of Fields */}
      {/* <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6 text-left"> */}
        <div className="relative">
          <label htmlFor="phoneNumber" className="absolute text-sm text-gray-500 top-2 left-3 bg-white px-1">Phone Number</label>
          <input 
            id="phoneNumber" 
            type="text" 
            value={formData.phoneNumber || ''} 
            className="w-full p-2 border rounded" 
            onChange={handleChange} 
          />
          <p className="text-gray-500 text-xs mt-1">Please enter Phone Number</p>
        </div>
        <div className="relative">
          <label htmlFor="emailAddress" className="absolute text-sm text-gray-500 top-2 left-3 bg-white px-1">Email Address</label>
          <input 
            id="emailAddress" 
            type="text" 
            value={formData.emailAddress || ''} 
            className="w-full p-2 border rounded" 
            onChange={handleChange} 
          />
          <p className="text-gray-500 text-xs mt-1">Please enter Email Address</p>
        </div>
        <div className="relative">
          <label htmlFor="website" className="absolute text-sm text-gray-500 top-2 left-3 bg-white px-1">Website</label>
          <input 
            id="website" 
            type="text" 
            value={formData.website || ''} 
            className="w-full p-2 border rounded" 
            onChange={handleChange} 
          />
          <p className="text-gray-500 text-xs mt-1">Please enter Website</p>
        </div>

      {/* Fourth Row of Fields */}
      {/* <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6 text-left"> */}
        <div className="relative">
          <label htmlFor="nationalRanking" className="absolute text-sm text-gray-500 top-2 left-3 bg-white px-1">National Ranking</label>
          <input 
            id="nationalRanking" 
            type="text" 
            value={formData.nationalRanking || ''} 
            className="w-full p-2 border rounded" 
            onChange={handleChange} 
          />
          <p className="text-gray-500 text-xs mt-1">Please enter National Ranking</p>
        </div>

        <div className="relative">
          <label htmlFor="internationalRanking" className="absolute text-sm text-gray-500 top-2 left-3 bg-white px-1">International Ranking</label>
          <input 
            id="internationalRanking" 
            type="text" 
            value={formData.internationalRanking || ''} 
            className="w-full p-2 border rounded" 
            onChange={handleChange} 
          />
          <p className="text-gray-500 text-xs mt-1">Please enter International Ranking</p>
        </div>

        <div className="relative">
          <label htmlFor="foundedYear" className="absolute text-sm text-gray-500 top-2 left-3 bg-white px-1">Founded Year</label>
          <input 
            id="foundedYear" 
            type="number" 
            value={formData.foundedYear || ''} 
            className="w-full p-2 border rounded" 
            onChange={handleChange} 
          />
          <p className="text-gray-500 text-xs mt-1">Please enter the year University was established</p>
        </div>
      </div>
    </form>
  );
}

export default AddUniversity;
